function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import blockContent from '../fragments/blockContent.js';
import columnInfoGroup from './columnInfoGroup.js';
import mediaSection from './mediaSection.js';
import simpleDatalistSection from './simpleDatalistSection.js';
import callToActionsBlock from './callToActionsBlock.js';
import requiredImage from '../fragments/requiredImage.js';
var schema = defineObject('bigTitleSection', {
    variant: {
        title: 'Variant',
        type: 'string',
        options: {
            list: [
                'simple',
                'columns'
            ]
        }
    },
    title: {
        title: 'Title',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    primaryContent: _object_spread({
        title: 'Primary Content'
    }, blockContent.fragment),
    secondaryContent: _object_spread({
        title: 'Secondary Content',
        description: 'Only used for "columns" variant'
    }, blockContent.fragment),
    image: {
        title: 'Image',
        type: 'image',
        options: requiredImage.fragment.options
    }
}, [
    mediaSection.schema.mediaSection,
    columnInfoGroup.schema.columnInfoGroup,
    simpleDatalistSection.schema.simpleDatalistSection,
    callToActionsBlock.schema.callToActionsBlock
]);
var validator = z.object({
    variant: z.enum([
        'simple',
        'columns'
    ]),
    title: z.string(),
    primaryContent: blockContent.validator,
    secondaryContent: blockContent.validator,
    image: requiredImage.validator.optional()
}).partial();
schema.bigTitleSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=bigTitleSection.js.map